import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { lastValueFrom } from "rxjs";
import { ManufacturerMapping } from "../../Model/dataProcess/manufacturerMapping";
import { CatalogMappingSuggestionResult } from "../../Model/dataProcess/catalogMappingSuggestion";
import { LoginService } from "../login.service";

@Injectable()
export class ManufacturerService {
    private readonly apiUrl = 'api/Manufacturer';

    constructor(private http: HttpClient, private loginService: LoginService) {
    }

    public getCatalogMappings(catalogId: string, customerId: string): Promise<ManufacturerMapping[]> {
        const url = `${this.apiUrl}/GetCatalogMappings`;
        const params = new HttpParams().append('catalogId', catalogId).append('customerId', customerId);
        return lastValueFrom(this.http.get<ManufacturerMapping[]>(url, { params }));
    }

    public saveCatalogMapping(model: ManufacturerMapping, customerId: string): Promise<ManufacturerMapping> {
        const url = `${this.apiUrl}/SaveCatalogMapping`;
        const params = new HttpParams().append('customerId', customerId);
        return lastValueFrom(this.http.post<ManufacturerMapping>(url, model, { params }));
    }

    public deleteCatalogMapping(model: ManufacturerMapping, customerId: string): Promise<void> {
        const url = `${this.apiUrl}/DeleteCatalogMapping`;
        const params = new HttpParams().append('customerId', customerId).append('id', model.id);
        return lastValueFrom(this.http.delete<void>(url, { params }));
    }

    public suggestCatalogMapping(sources: string[], containerId: string, catalogId: string): Promise<CatalogMappingSuggestionResult> {
        const url = `${this.apiUrl}/SuggestCatalogMapping`;
        return lastValueFrom(this.http.post<CatalogMappingSuggestionResult>(url, {
            customerId: this.loginService.currentCustomer.id,
            containerId: containerId,
            catalogId: catalogId,
            sources: sources
        }));
    }
}
